"use client";

import { sendGTMEvent } from "@/helpers/sendGTMEvent";
import { trackPartnerLead } from "@/helpers/trackPartnerLead";
import { AFFILIATE_SIGNUP_GTM_COOKIE } from "@/lib/auth/affiliateSignupCookies";
import { useAuth } from "@/providers/AuthProvider";
import { useCodiea } from "@codiea/tracking/react";
import Cookies from "js-cookie";
import { useEffect, useRef } from "react";

export function AffiliateSignupGtm() {
  const { user, isAuthLoading } = useAuth();
  const { track, identify } = useCodiea();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    if (Cookies.get(AFFILIATE_SIGNUP_GTM_COOKIE) !== "1") return;
    if (isAuthLoading) return;

    handled.current = true;

    sendGTMEvent({
      event: "affiliate_signup",
      signup_type: "affiliate",
    });

    const email = user?.email || undefined;
    const name = user?.name || undefined;

    trackPartnerLead({ track, identify }, "affiliate", {
      email,
      name,
      phone: user?.phone_number || undefined,
    });

    void track({
      event: "sign_up",
      userId: user?.id != null ? String(user.id) : undefined,
      properties: {
        email,
        method: "social",
      },
    });

    Cookies.remove(AFFILIATE_SIGNUP_GTM_COOKIE, { path: "/" });
  }, [isAuthLoading, user, track, identify]);

  return null;
}
